import DownloadIcon from '@/common/assets/icons/download.svg?react';
import MainModal from '@/common/components/base/modal/Modal';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import Typography from '@/common/components/base/typography/Typography';
import CardButton from '@/common/components/cardButton/CardButton';
import { Box, Flex } from 'styled-system/jsx';
import { token } from 'styled-system/tokens';
import { useParams } from 'react-router-dom';
import { FileImageZipModalType } from '@/modules/FileDetail/components/documentation/modals/FileImageZipModal/FileImageZipModal.type';
import CircularLoading from '@/common/components/base/Loading/CircularLoading';
import { useState } from 'react';

export default ({
  closeModal,
  open,
  downloadFunction,
  isPending,
}: FileImageZipModalType) => (
  <MainModal open={open} closeModal={closeModal}>
    <FileImageZipModal
      downloadFunction={downloadFunction}
      isPending={isPending}
    />
  </MainModal>
);

const FileImageZipModal = ({
  downloadFunction,
  isPending,
}: Pick<FileImageZipModalType, 'downloadFunction' | 'isPending'>) => {
  const { id } = useParams();
  const [isHigh, setIsHigh] = useState(false);

  return (
    <>
      <TitleDescription textStyle="h2" color="black-1">
        دانلود
      </TitleDescription>
      <CardButton
        title="دانلود همراه با عکس (با کیفیت بالا)"
        hasArrow={false}
        renderTag={() => (
          <Flex gap="3" alignItems="center">
            {isPending && isHigh ? (
              <CircularLoading color="colors.purple-3" width="20px" />
            ) : (
              <DownloadIcon stroke={token('colors.purple-2')} />
            )}
            <Typography textStyle="b2" color="purple-2">
              دانلود
            </Typography>
          </Flex>
        )}
        cardProps={{
          boxShadow: 'none',
          onClick: () => {
            setIsHigh(true);
            downloadFunction({
              id: id!,
              images_quality: 'high',
            });
          },
        }}
      />
      <Box mx="1rem" borderBottom="1px solid {colors.gray-2}" />
      <CardButton
        title="دانلود همراه با عکس (با کیفیت پایین)"
        hasArrow={false}
        renderTag={() => (
          <Flex gap="3" alignItems="center">
            {isPending && !isHigh ? (
              <CircularLoading color="colors.purple-3" width="20px" />
            ) : (
              <DownloadIcon stroke={token('colors.purple-2')} />
            )}
            <Typography textStyle="b2" color="purple-2">
              دانلود
            </Typography>
          </Flex>
        )}
        cardProps={{
          boxShadow: 'none',
          onClick: () => {
            setIsHigh(false);
            downloadFunction({
              id: id!,
              images_quality: 'low',
            });
          },
        }}
      />
      <Box mx="1rem" borderBottom="1px solid {colors.gray-2}" />
    </>
  );
};
